import ClientRole from '../enums/clientRole';
import Role from '../enums/role';
import RoleCategory from '../enums/roleCategory';
import uniq from 'lodash.uniq';
const clientRoleMap = [
    {
        id: ClientRole.Universal,
        name: 'CLIENT.ROLES.UNIVERSAL',
        value: [Role.Universal],
        category: RoleCategory.Contributor
    },
    {
        id: ClientRole.CreatorAndApprover,
        name: 'CLIENT.ROLES.CREATOR_AND_APPROVER',
        value: [Role.Creator, Role.Approver],
        category: RoleCategory.Contributor
    },
    {
        id: ClientRole.Verifier,
        name: 'CLIENT.ROLES.VERIFIER',
        value: [Role.Verifier],
        category: RoleCategory.Contributor
    },
    {
        id: ClientRole.Watcher,
        name: 'CLIENT.ROLES.WATCHER',
        value: [Role.Watcher],
        category: RoleCategory.Inspector
    }
];
export const getClientRoleNameById = (id) => clientRoleMap.find((item) => item.id === id).name;
const getRolesByClientRoleId = (id) => clientRoleMap.find((item) => item.id === id).value;
const getClientRolesByRoleId = (role) => clientRoleMap.find((item) => item.value.includes(role)).id;
export const getClientRoleCategoryById = (id) => clientRoleMap.find((item) => item.id === id).category;
export const getRolesFromClientRoles = (roles) => roles.flatMap(getRolesByClientRoleId);
export const getClientRolesFromRoles = (roles) => uniq(roles.flatMap(getClientRolesByRoleId));
